<template lang="pug">
	modal
		.card.text-left
			.card-header
				| Propuestas comerciales
				button.close(@click="cerrar") &times;
			.card-body
				h4
					span.fa.fa-info.mr-2
					| Información de la propuesta
				div.row
					.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
						.form-group
							label Agente
							input-query(v-if="!propuesta.usuario_ID", :realtime="true", url="/agenda-comercial/php/api/busca-agentes.php", input-class="form-control form-control-sm", @selected="ponAgente($event)")
							div.input-group(v-if="propuesta.usuario_ID")
								input.form-control.form-control-sm(
									disabled="disabled",
									:value="propuesta.usuarioInfo",
								)
								div.input-group-append(v-if="editable && permisos.agenda_comercial_crear_todos")
									button.btn.btn-sm.btn-danger(@click="quitarAgente")
										span.fa.fa-trash
					.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
						.form-group
							label Empresa
							select.form-control.form-control-sm(v-model="propuesta.empresa_ID", :disabled="!editable")
								option(:value="null") Selecciona
								option(v-for="empresa in listadoEmpresas", :key="empresa.ID_empresa", :value="empresa.ID_empresa") {{empresa.nombreFiscal}}
				div.row.mt-2
					.col-xs-12.col-sm-12.col-md-12.col-lg-12.col-xl-12
						.form-group
							label Cliente
							input-query(:disabled="!propuesta.usuario_ID", v-if="!propuesta.cliente_ID", :realtime="true", :url="'/agenda-comercial/php/api/busca-clientes.php?agente=' + propuesta.usuario_ID", input-class="form-control form-control-sm", @selected="ponCliente($event)")
							div.input-group(v-if="propuesta.cliente_ID")
								input.form-control.form-control-sm(
									disabled="disabled",
									:value="propuesta.clienteInfo",
								)
								div.input-group-append(v-if="!idCliente && editable")
									button.btn.btn-sm.btn-danger(@click="quitarCliente")
										span.fa.fa-trash
				.form-group
					label Título
					input.form-control(:disabled="!editable", v-model="propuesta.titulo")
				.form-group
					label Descripción
					textarea.form-control(rows="4", :disabled="!editable", v-model="propuesta.descripcion")
			.card-body.bg-light
				h4
					span.fa.fa-money.mr-2
					| Productos
					button.btn.btn-sm.btn-primary.pull-right(@click="nuevaLinea", v-if="editable")
						span.fa.fa-plus

				// Aquí las líneas de la propuesta
				div.lineasContainer
					div.linea(v-if="propuesta.lineas.length > 0")
						div.descripcion Descripción / Producto
						div Cantidad
						div Descuento
						div P. unitario
						div Bruto
						div Forzado
						div Total
						div(v-if="editable", style="max-width:30px;min-width:20px;")
					div.linea(v-for="(linea, index) in propuesta.lineas", :key="linea.ID_linea")
						div.descripcion
							.input-group
								.input-group-prepend
									button.btn.btn-sm(:disabled="!editable", title="Tarifa", :class="(linea.tipo === 'tarifa') ? 'btn-primary' : ''", @click="setTipo(propuesta.lineas[index], 'tarifa')")
										span.fa.fa-list
									button.btn.btn-sm(:disabled="!editable", title="Concepto", :class="(linea.tipo === 'concepto') ? 'btn-primary' : ''", @click="setTipo(propuesta.lineas[index], 'concepto')")
										span.fa.fa-edit
								input.form-control.form-control-sm(:disabled="!editable", v-if="linea.tipo === 'concepto'", v-model="linea.concepto", placeholder="Escribe un concepto")
								input-query(
									v-if="linea.tipo === 'tarifa' && linea.tarifa_ID === null",
									placeholder="Busca la tarifa",
									:realtime="true",
									@selected="seleccionaTarifa(propuesta.lineas[index], $event)",
									url="/agenda-comercial/php/api/busca-productos.php",
									input-class="form-control form-control-sm")
								input.form-control.form-control-sm(
									v-if="linea.tarifa_ID !== null",
									:value="linea.concepto",
									placeholder="Concepto",
									disabled="true"
								)
								div.input-group-append(
									v-if="linea.tarifa_ID && editable"
								)
									button.btn.btn-danger.btn-sm(@click="quitarTarifa(propuesta.lineas[index])")
										span.fa.fa-trash
						div
							input.form-control.form-control-sm(:disabled="!editable || !linea.concepto", type="number", placeholder="0", v-model.number="propuesta.lineas[index].cantidad")
						div
							input.form-control.form-control-sm(:disabled="(linea.forzado > 0 || linea.forzado < 0 || !editable || !linea.concepto)", type="number", placeholder="0", v-model.number="propuesta.lineas[index].descuento")
						div
							input.form-control.form-control-sm(type="number", placeholder="0", v-model.number="propuesta.lineas[index].precio_unitario", :disabled="linea.tipo === 'tarifa' || !editable || !linea.concepto")
						div
							input.form-control.form-control-sm(:disabled="true", type="number", placeholder="0", v-model.number="propuesta.lineas[index].precio_unitario * propuesta.lineas[index].cantidad")
						div
							input.form-control.form-control-sm(:disabled="!editable || !linea.concepto", type="number", placeholder="0", v-model.number="propuesta.lineas[index].forzado")
						div
							input.form-control.form-control-sm(disabled="true", :value="getTotal(propuesta.lineas[index])")
						div(v-if="editable", style="max-width:30px;min-width:20px;text-align:right;")
							button.btn.btn-sm.btn-danger(@click="quitarLinea(linea.ID_linea)")
								span.fa.fa-trash
			.card-body(v-if="propuesta.lineas.length > 0")
				h4 
					span.fa.fa-edit.mr-2
					| Modificaciónes finales (opcionales)
				.alert.alert-info
					| Rellena estos cambos <b>solamente</b> si quieres alterar el precio final. Si se va a quedar como está no los modifiques.
				.row
					.col.text-left
						.input-group
							.input-group-prepend
								.input-group-text Descuento global
							input.form-control.form-control-sm(:disabled="(propuesta.forzado > 0 || propuesta.forzado < 0 || !editable)", v-model.number="propuesta.descuento")
							.input-group-append
								.input-group-text %
			.card-body.text-right
				h3.text-danger Total propuesta: {{totalPropuesta | currency('€')}}
			.card-footer
				button.btn.btn-primary(@click="guardar", v-if="editable && formValido")
					span.fa.fa-save.mr-2
					| Guardar
				button.btn.btn-warning.ml-2(@click="descargar", v-if="propuesta.ID_propuesta")
					span.fa.fa-download.mr-2
					| Descargar
				a.btn.btn-warning(style="display:none;", ref="linkDescarga", download="Propuesta.pdf", :href="'/src/modulos/agenda-comercial/php/api/get-propuesta-pdf.php?ID_propuesta=' + propuesta.ID_propuesta")
					span.fa.fa-download.mr-2
					| Descargar
</template>


<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
	props: ['idCliente', 'idAgente', 'idPropuesta', 'copiar'],
	data () {
		return {
			indice: 0,
			propuesta: {
				ID_propuesta: null,
				empresa_ID: null,
				cliente_ID: null,
				clienteInfo: null,
				usuario_ID: null,
				usuarioInfo: null,
				titulo: null,
				descripcion: null,
				descuento: 0,
				fecha_presentada: null,
				lineas: []
			},
			listadoEmpresas: []
		}
	},

	created () {
		// Obtenemos el listado de empresas
		axios.get('/agenda-comercial/php/api/get-listado-empresas.php')
			.then(res => {
				this.listadoEmpresas = res.data
			})
			.catch(e => {
				this.$store.commit('totast/danger', {
					titulo: 'Error',
					mensaje: 'Error obteniendo el listado de empresas'
				})
			})

		if (this.copiar) {
			axios.get('/agenda-comercial/php/api/get-propuesta.php?ID_propuesta=' + this.copiar)
				.then(res => {
					this.propuesta = res.data.propuesta
					this.propuesta.fecha_presentada = null
					this.propuesta.ID_propuesta = null

					if (typeof this.idCliente === 'number') {
						this.propuesta.cliente_ID = this.idCliente + 0

						// Ahora buscamos la información del cliente
						axios.get('/agenda-comercial/php/api/get-cliente.php?ID_cliente=' + this.idCliente)
							.then(res => {
								this.propuesta.clienteInfo = res.data.cliente.cliente
							})
							.catch(e => {
								this.propuesta.clienteInfo = 'Cliente no encontrado'
							})
					}

					if (typeof this.idAgente === 'number') {
						this.propuesta.usuario_ID = this.idAgente + 0

						axios.get('/agenda-comercial/php/api/get-agente.php?ID_agente=' + this.idAgente)
							.then(res => {
								this.propuesta.usuarioInfo = res.data.agente.nombre + ' ' + res.data.agente.apellidos
							})
							.catch(e => {
								this.propuesta.usuarioInfo = 'Agente no encontrado'
							})
					}
				})
				.catch(this.$responseError)
			return
		}

		if (this.idPropuesta && this.idPropuesta !== 'nueva') {
			axios.get('/agenda-comercial/php/api/get-propuesta.php?ID_propuesta=' + this.idPropuesta)
				.then(res => {
					this.propuesta = res.data.propuesta
				})
				.catch(this.$responseError)
			return
		}

		if (typeof this.idCliente === 'number') {
			this.propuesta.cliente_ID = this.idCliente + 0

			// Ahora buscamos la información del cliente
			axios.get('/agenda-comercial/php/api/get-cliente.php?ID_cliente=' + this.idCliente)
				.then(res => {
					this.propuesta.clienteInfo = res.data.cliente.cliente
				})
				.catch(e => {
					this.propuesta.clienteInfo = 'Cliente no encontrado'
				})
		}

		if (typeof this.idAgente === 'number') {
			this.propuesta.usuario_ID = this.idAgente + 0

			axios.get('/agenda-comercial/php/api/get-agente.php?ID_agente=' + this.idAgente)
				.then(res => {
					this.propuesta.usuarioInfo = res.data.agente.nombre + ' ' + res.data.agente.apellidos
				})
				.catch(e => {
					this.propuesta.usuarioInfo = 'Agente no encontrado'
				})
		}
	},

	computed: {
		...mapGetters({
			'usuario': 'session/usuario',
			'permisos': 'permisos/permisos'
		}),
		formValido () {
			if (!this.propuesta.usuario_ID) {
				return false
			}

			if (!this.propuesta.empresa_ID) {
				return false
			}

			if (!this.propuesta.cliente_ID) {
				return false
			}

			if (!this.propuesta.titulo) {
				return false
			}

			if (this.propuesta.lineas.length === 0) {
				return false
			}

			return true
		},
		totalPropuesta () {
			return this.propuesta.importe
			// let importe = 0

			// for (let i = 0; i < this.propuesta.lineas.length; i++) {
			// 	importe = importe + (this.propuesta.lineas[i].importe * (100 - this.propuesta.lineas[i].descuento) / 100)
			// }

			// return importe
		},
		editable () {
			// TODO: En el futuro las propeustas no serán editables una vez se hayan presentado
			return (this.propuesta.fecha_presentada === null)
		}
	},
	methods: {
		nuevaLinea () {
			this.propuesta.lineas.push({
				ID_linea: 'nueva' + (++this.indice),
				tarifa_ID: null,
				empresa_ID: null,
				tipo: 'tarifa',
				concepto: '',
				cantidad: 1,
				descuento: 0,
				precio_unitario: 0,
				forzado: null,
				importe: 0
			})
		},

		quitarLinea (ID) {
			for (let i = 0; i < this.propuesta.lineas.length; i++) {
				if (this.propuesta.lineas[i].ID_linea === ID) {
					this.propuesta.lineas.splice(i, 1)
				}
			}
		},

		ponAgente (ev) {
			this.propuesta.usuario_ID = ev.datos.ID
			this.propuesta.usuarioInfo = ev.datos.nombre + ' ' + ev.datos.apellidos
		},

		quitarAgente () {
			this.propuesta.usuario_ID = null
			this.propuesta.cliente_ID = null
			this.propuesta.usuarioInfo = null
			this.propuesta.clienteInfo = null
		},

		ponCliente (ev) {
			this.propuesta.cliente_ID = ev.datos.ID
			this.propuesta.clienteInfo = ev.datos.cliente
		},

		quitarCliente () {
			this.propuesta.cliente_ID = null
			this.propuesta.clienteInfo = null
		},

		setTipo (linea, tipo) {
			linea.tipo = tipo
			linea.concepto = null
			linea.tarifa_ID = null
			linea.precio_unitario = null
		},

		seleccionaTarifa (linea, ev) {
			linea.tarifa_ID = ev.datos.ID_tarifa
			linea.precio_unitario = parseFloat(ev.datos.precio)
			linea.concepto = ev.datos.titulo
		},

		quitarTarifa (linea) {
			linea.tarifa_ID = null
			linea.importe = 0
			linea.forzado = null
			linea.descuento = null
			linea.concepto = null
			linea.tarifa_ID = null
			linea.precio_unitario = null
		},

		getTotal (linea) {
			let importe = 0
			if (typeof linea.forzado === 'number' && linea.forzado !== 0) {
				importe = linea.forzado + 0

				// Calculamos el descuento
				const descuento = 100 - (linea.forzado * 100 / (linea.precio_unitario * linea.cantidad))
				linea.descuento = descuento + 0
			} else {
				let pUnitario, cantidad, descuento

				try {
					pUnitario = (typeof linea.precio_unitario === 'number') ? linea.precio_unitario : 0
					cantidad = (typeof linea.cantidad === 'number') ? linea.cantidad : 0
					descuento = (typeof linea.descuento === 'number') ? linea.descuento : 0
				} catch (e) {
					return 0
				}

				importe = pUnitario * cantidad

				if (descuento !== 0) {
					importe = importe - (importe * descuento / 100)
				}
			}

			if (typeof this.propuesta.descuento === 'number') {
				importe = importe - (importe * this.propuesta.descuento / 100)
			}

			linea.importe = importe
			return importe
		},

		guardar () {
			axios.post('/agenda-comercial/php/api/set-propuesta.php', this.propuesta)
				.then(res => {
					this.$emit('saved', res.data.propuesta)
					this.cerrar()

					this.$store.commit('toast/success', {
						titulo: 'Propuesta guardada',
						mensaje: 'Se ha guardado la propuesta correctamente'
					})
				})
				.catch(this.$responseError)
		},

		descargar () {
			if (this.propuesta.impresa || !this.editable) {
				this.$refs.linkDescarga.click()
			} else {
				this.$store.commit('alertas/confirm', {
					titulo: 'Descargar propuesta',
					mensaje: `Estás a punto de exportar esta propuesta.
					Una vez continúes, ya no podrás editarla de nuevo. Si quieres modificarla, tendrás que crear una nueva.
					¿Quieres continuar?`,
					callback: acepta => {
						if (acepta) {
							this.$refs.linkDescarga.click()
						}
					}
				})
			}
		},

		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>


<style scoped>
	.lineasContainer {
		display: flex;
		flex: 1 1;
		flex-direction: column;
		align-items: stretch;
	}

	.linea {
		display: flex;
		position: relative;
		flex: 1 1;
		flex-direction: row;
		align-items: flex-start;
		align-content: flex-start;
		flex-wrap: nowrap;
		box-sizing: border-box;
		margin-top: 2px;
	}

	.descripcion {
		min-width: 70px;
		max-width: 100% !important;
	}

	.linea > div {
		box-sizing: border-box;
		flex: 1 0;
		min-width: 50px;
		max-width: 80px;
		padding: 2px;
	}

	input {
		-webkit-appearance: none; 
  		margin: 0;
		-moz-appearance:textfield;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/agenda-comercial/vue/componentes/propuestas/editor-propuestas.vue